import { SET_INITIAL_THEME_MODE, SET_THEME_MODE, TOGGLE_DARK_MODE } from "../actions/ActionConstant"

const initialState = {
    isDark: false,
}

const ThemeReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_DARK_MODE:
            return {
                ...state,
                 isDark: !state.mode
            }
        case SET_INITIAL_THEME_MODE:
            let mode =  localStorage.getItem('isDark') === 'true' ? true : false;
            return {
                ...state,
                isDark: mode,
            }
        case SET_THEME_MODE:
            action.data ? localStorage.setItem('isDark', true): localStorage.setItem('isDark', false)
            return {
                ...state,
                isDark: action.data,
            }
        default:
        return {
            ...state
        }
    }
}

export default ThemeReducer;
